import { apiRoutes } from '../config/api'
import type { ToneRecipeDto } from '../models/toneRecipe'
import { get } from './httpClient'

export function getSongToneRecipe(songId: string, signal?: AbortSignal) {
  return get<ToneRecipeDto>(apiRoutes.songToneRecipe(songId), signal)
}
